import axios from 'axios'
import {SearchUrlParamBuilder} from '@/core/utils'

const URL_PATH = '/ata-registro-preco/api/public/adesao/anuencia'

class AssinaturaApiClient {
	async assinar(idEmailAdesaoFornec) {
		let url = `${URL_PATH}/${idEmailAdesaoFornec}/assinatura`

		return await axios.put(url, { idEmailAdesaoFornec: idEmailAdesaoFornec })
	}
}

export default new AssinaturaApiClient()
